import styled from 'styled-components';
import { media } from '@simplywallst/ui-core';

export const Value = styled('h4')`
  font-size: 28px;
  ${media.mdUp`
    ${({ theme }) => theme.typography.hero}
  `}
  margin-bottom: 0;
`;

export const Term = styled('span')`
  ${(props) => props.theme.typography.smallStrong}
  color: ${(props) => props.theme.color.whiteRGBA(0.7)};
  border-bottom: 1px dotted ${(props) => props.theme.color.brand01};
  cursor: help;
  width: fit-content;
`;

export const TipContainer = styled('p')`
  margin: 0;
  max-width: 200px;
  ${({ theme }) => theme.typography.tiny};
`;

export const ChartContainer = styled('div')`
  ${media.mdUp`
    margin-top: -${({ theme }) => theme.x3spacePx}px
  `}
`;

export const Growth = styled('span')`
  ${({ theme }) => theme.typography.small}
  color: ${({ theme }) => theme.color.whiteRGBA(0.5)};
  margin-top: 6px;
  height: 20px;
`;
